import script from "./ProblemHandlingResultDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProblemHandlingResultDialog.vue?vue&type=script&lang=ts&setup=true"

import "./ProblemHandlingResultDialog.vue?vue&type=style&index=0&id=96f83270&lang=scss&scoped=true"
import "./ProblemHandlingResultDialog.vue?vue&type=style&index=1&id=96f83270&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96f83270"]])

export default __exports__